/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React from 'react';
import {ReactComponent as Search} from "../assets/img/icons/search-box.svg";
import {useTranslation} from "react-i18next";

const SearchBox = (props) => {

    const { t, i18n } = useTranslation();

    return (
        <div className='search-box'>
            <div className='search-box__row'>
                <div className='search-box__icon'>
                    <Search/>
                </div>
                <div className='search-box__element'>
                    <input className='form-control' onChange={(e) => props.onSearch(e.target.value)} value={props.value} placeholder={t('parts.quickSearch')}/>
                </div>
            </div>
        </div>
    );
};

export default SearchBox;

